import { type Location } from "../model/types"

export const BOX_WIDTH = 30

export type PlaneLocation = {
  px: number
  py: number
}

export const grid_to_plane = ({ gx, gy }: Location): PlaneLocation => ({
  px: gx * BOX_WIDTH,
  py: gy * BOX_WIDTH,
})
